/*
 * Ergovo – Cart Drawer Smart-Recs + Schnellansicht (In-Drawer-Panel)
 * -----------------------------------------------------------------
 * 1) Smart-Recs: liest #ergovo-recs-catalog + /cart.js und wählt
 *    KATEGORIE-basiert passende Cross-Sells (Drawer-Zeile mobil,
 *    Seitenpanel Desktop).
 * 2) Quick View: lädt /products/{handle}.js und rendert eine kompakte
 *    Kauf-Ansicht DIREKT im Drawer (statt Popup) – mit „Zurück zum
 *    Warenkorb", flüssigem Wechseln zwischen Produkten.
 * Mobile-first. Defensiv (try/catch, Null-Checks).
 */
(function () {
  'use strict';

  /* ============================ Mappings ============================ */

  var CAT_NORMALIZE = {
    socken: 'socken',
    kopfkissen: 'schlaf', nackenkissen: 'schlaf', spezialkissen: 'schlaf',
    massagewellness: 'wellness',
    haltung: 'ruecken', sitzruecken: 'ruecken',
    koerperkomfort: 'koerper',
    schwangerschaft: 'schwangerschaft',
    schuhe: 'schuhe',
    reise: 'reise',
    'Kompressionssocken': 'socken',
    'Nackenstützkissen': 'schlaf', 'Kopfkissen': 'schlaf', 'Ohrkissen': 'schlaf',
    'Massagegerät': 'wellness', 'Akupressurmatte': 'wellness',
    'Haltungskorrektor': 'ruecken', 'Rückenkissen': 'ruecken', 'Sitzkissen': 'ruecken',
    'Lendenkissen': 'ruecken', 'Schoßkissen': 'ruecken',
    'Beinkissen': 'koerper', 'Kniekissen': 'koerper', 'Lesekissen': 'koerper',
    'Reisekissen': 'reise',
    'Schwangerschaftskissen': 'schwangerschaft',
    'Barfußschuhe': 'schuhe'
  };

  var AFFINITY = {
    socken:         ['schuhe', 'koerper', 'wellness'],
    schlaf:         ['wellness', 'reise', 'ruecken', 'koerper'],
    wellness:       ['ruecken', 'schlaf', 'socken'],
    ruecken:        ['wellness', 'koerper', 'socken'],
    koerper:        ['schlaf', 'wellness', 'ruecken'],
    schwangerschaft:['koerper', 'schlaf'],
    schuhe:         ['socken', 'koerper', 'wellness'],
    reise:          ['schlaf', 'socken', 'wellness']
  };

  // Bullets basierend auf den kundenseitigen USPs der echten Produktseiten (PDP)
  var BULLETS_BY_HANDLE = {
    'kompressionssocken': [
      'Graduierte Kompression – aktiviert spürbar die Venenpumpe',
      'Weniger Schwere & geschwollene Beine ab dem ersten Tragen',
      'Atmungsaktiv & verstärkt an Ferse und Zehen',
      'Ideal für Stehberuf, Sport, Reise & lange Flüge'
    ],
    'deepsleep': [
      'Entlastet Wirbelsäule & unterstützt Nacken',
      'Löst Steifheit, Schmerzen und unruhige Nächte',
      'Premium Memory-Schaum, ergonomisch geformt',
      'Für Rücken-, Seiten- & Bauchschläfer'
    ],
    'ergovo-deepsleep-ersatzbezug': [
      'Passt exakt auf dein Ergovo DeepSleep Kissen',
      'Atmungsaktiver, hautfreundlicher Stoff – angenehm über Nacht',
      'Bei 40 °C maschinenwaschbar – schnell wieder frisch',
      'Zweitbezug zum Wechseln – immer einer frisch im Schrank'
    ],
    'massagegerat': [
      'Knetmassage-Köpfe mit Infrarot-Tiefenwärme',
      'Mehrere Intensitätsstufen – individuell anpassbar',
      'Entlastet Nacken, Schultern & Trapezmuskel',
      'Täglich entspannen – ohne Termin, ohne Wartezeit'
    ],
    'rueckengurt': [
      'Öffnet die Schultern & korrigiert die Haltung – sofort spürbar',
      'Unauffällig unter der Kleidung tragbar',
      'Atmungsaktiv & stufenlos verstellbar',
      'Ideal für Büro, Homeoffice & Alltag'
    ],
    'elevationskissen': [
      'Legt beide Beine bequem hoch – fördert den venösen Rückfluss',
      'Reduziert Schwellungen in Füßen, Knöcheln & Beinen',
      'Formstabiler Keil mit rutschfester Basis',
      'Faltbar & vielseitig – für Bett, Sofa & Büro'
    ],
    'premium-memoryfoamkissen': [
      'Höhe selbst einstellen – Füllung einfach herausnehmen',
      'Kühlende Seite & normale Seite – einfach wenden',
      'Anpassungsfähiger Memory-Schaum für optimale Stütze',
      'Für Seiten-, Rücken- & Bauchschläfer · Bezug waschbar'
    ],
    'rueckenkissen': [
      'Memory-Schaum entlastet Lendenwirbel & Bandscheiben sofort',
      'Passgenauer Halt für Bürostuhl, Autositz & Rollstuhl',
      'Atmungsaktives Netzgewebe – kein Hitzestau, auch nach Stunden',
      'Stabiler Verstellgurt – passt auf jeden Stuhl'
    ],
    'gel-sitzkissen': [
      'Waben-Gel verteilt den Druck gleichmäßig – kein Taubheitsgefühl',
      'Offene Wabenstruktur sorgt für Luftzirkulation – kein Hitzestau',
      'Steißbein-Ausschnitt entlastet gezielt den unteren Rücken',
      'Waschbarer Bezug – für Bürostuhl, Auto & Rollstuhl'
    ],
    'kniestuetzkissen': [
      'Langsam rückstellender Memory-Schaum passt sich an',
      'Konturform – kein harter Druck zwischen den Knien',
      'Gurt hält das Kissen die ganze Nacht in Position',
      'Für Seitenschläfer, Schwangere & bei Hüft-/Knieschmerzen'
    ],
    'lesekissen': [
      'Stützt Rücken, Nacken & Arme – entspannt für Stunden',
      'Weicher Stoff – abnehmbar & maschinenwaschbar',
      'Für Lesen, Serien, Stillen & Schwangerschaft',
      'Ergonomische Form für aufrechtes, entspanntes Sitzen'
    ],
    'bett-lesekissen': [
      'Endlich aufrecht im Bett sitzen – ohne Rückenschmerzen',
      'Stützt Rücken und beide Arme gleichzeitig',
      'Samtweicher Bezug – angenehm zur Haut',
      'Für Bett & Sofa – ideal zum Lesen, Arbeiten & Streamen'
    ],
    'schwangerschaftskissen': [
      'U-Form stützt Bauch, Rücken, Hüfte & Beine gleichzeitig',
      'Beidseitig – kein Umlagern beim Drehen in der Nacht',
      'Abnehmbarer Samtbezug – maschinenwaschbar',
      'Für Schwangere & Seitenschläfer – auch als Stillkissen'
    ],
    'barfusssneaker': [
      'Breite Zehenbox – natürliche Zehenstellung ohne Einengen',
      'Zero-Drop-Sohle – aufrechte Haltung von Ferse bis Zehe',
      'Atmungsaktives Mesh – leicht & luftig für lange Tage',
      'Herausnehmbare Einlegesohle für gedämpften Komfort'
    ],
    'barfussschuhe': [
      'Breite Zehenbox – die Zehen spreizen sich natürlich',
      'Null-Absatz & flexible Sohle – aktiviert die Fußmuskulatur',
      'Rutschfeste Sohle – sicherer Halt drinnen & draußen',
      'Barfußgefühl, das du bei jedem Schritt spürst'
    ],
    'grip-barfussschuhe': [
      'Mid-Top-Schaft schützt & stabilisiert den Knöchel',
      'Wasserabweisend – trocken bei Regen, Schlamm & Schnee',
      'Aggressive Profilsohle – Grip auf Fels, Laub & Geröll',
      'Weite Zehenbox & Zero-Drop – natürlicher Gang ohne Druck'
    ],
    'akupressurmatte': [
      'Über 6.000 Akupressur-Spitzen für Rücken, Nacken & Schultern',
      'Löst Verspannungen & fördert die Durchblutung',
      'Spürbare Entspannung schon nach wenigen Minuten',
      'Inkl. Nackenkissen & Tragetasche – überall einsetzbar'
    ],
    'c-schwangerschaftskissen': [
      'C-Form stützt Bauch, Rücken & Hüfte gleichzeitig',
      'Belegt nur eine Betthälfte – Partner behält seinen Platz',
      'Abnehmbarer Samtbezug – waschbar',
      'Für alle Schwangerschaftsphasen & als Stillkissen'
    ],
    'reisekissen': [
      'Memory-Foam passt sich deiner Nackenform an – ohne Druckstellen',
      'Clip-Verschluss – der Kopf kippt nicht seitlich weg',
      'Abnehmbarer Samtbezug – maschinenwaschbar & hautfreundlich',
      'Perfekt für Flugzeug, Bahn, Auto & Büropausen'
    ],
    'gamer-kissen': [
      'Ringform um die Taille – beide Arme ruhen entspannt auf',
      'Entlastet Schultern & Nacken beim Zocken, Lesen & Streamen',
      'Weicher Plüsch – samtweich direkt auf der Haut',
      'Formstabile Füllung – behält dauerhaft ihre Form'
    ],
    'lendenstuetzkissen': [
      'Memory-Schaum formt sich exakt deiner Lendenwirbelsäule an',
      'Hebt den unteren Rücken in die natürliche Lordose',
      'Schluss mit Rückenschmerzen beim Liegen',
      'Zum Hinlegen statt Sitzen · atmungsaktiver Mesh-Bezug'
    ],
    'o-kissen': [
      'O-förmige Aussparung – das Ohr liegt komplett druckfrei',
      'Erhöhte Ränder stützen den Kopf, das Ohr hängt frei',
      'Atmungsaktiver, gesteppter Bezug – hautfreundlich',
      'Ideal bei frischen Ohr-Piercings, CNH & für Seitenschläfer'
    ]
  };

  // Fallback je Kategorie
  var BULLETS = {
    socken: ['Spürbar leichtere, energiegeladene Beine', 'Abgestufte Kompression', 'Atmungsaktiv & hautfreundlich', 'Ideal für Sport, Reise & Stehberufe'],
    schlaf: ['Entlastet Nacken & Wirbelsäule', 'Ergonomische Stützform aus Memory Foam', 'Atmungsaktiver, waschbarer Bezug', 'Für Seiten- & Rückenschläfer'],
    wellness: ['Löst Verspannungen gezielt', 'Fördert die Durchblutung', 'Einfache Anwendung für Zuhause', 'Spürbare Tiefenentspannung'],
    ruecken: ['Unterstützt eine aufrechte Haltung', 'Entlastet den unteren Rücken', 'Ergonomisch & verstellbar', 'Ideal für Büro, Auto & Alltag'],
    koerper: ['Gezielte Druckentlastung', 'Hochwertiger Memory Foam', 'Ergonomische Passform', 'Mehr Komfort im Alltag'],
    schwangerschaft: ['Stützt Bauch, Rücken & Beine', 'Ganzkörper-Seitenschläferkomfort', 'Weicher, waschbarer Bezug', 'Begleitet dich durch die Schwangerschaft'],
    schuhe: ['Natürliches Barfußgefühl', 'Breite Zehenbox', 'Zero-Drop für gesunde Haltung', 'Ultraleicht & flexibel'],
    reise: ['Optimale Nackenstütze unterwegs', 'Kompakt & leicht', 'Druckentlastender Memory Foam', 'Abnehmbarer, waschbarer Bezug'],
    default: ['Premium-Qualität von Ergovo', 'Durchdacht & ergonomisch geformt', 'Für spürbar mehr Wohlbefinden', 'Risikofrei testen – unkomplizierte Rückgabe']
  };

  var TRUST_BADGES = [
    { t: 'Kostenloser Versand', s: 'ab 50 €' },
    { t: 'Deutsches Start-Up', s: 'aus Nürnberg' },
    { t: 'Später bezahlen', s: 'Kauf auf Rechnung' }
  ];

  var COLOR_HEX = {
    'blau': '#2563eb', 'dunkelblau': '#1e3a8a', 'hellblau': '#7dd3fc', 'türkis': '#14b8a6', 'tuerkis': '#14b8a6',
    'grau': '#9ca3af', 'hellgrau': '#d1d5db', 'dunkelgrau': '#4b5563',
    'schwarz': '#111827', 'weiß': '#ffffff', 'weiss': '#ffffff', 'mix': 'linear-gradient(135deg,#2563eb 50%,#111827 50%)',
    'grün': '#22c55e', 'gruen': '#22c55e', 'rosa': '#f9a8d4', 'lila': '#a855f7', 'pink': '#ec4899', 'rot': '#ef4444', 'beige': '#e7d8c2'
  };

  var REC_LIMIT = 6;
  var QV_REC_LIMIT = 4;
  var FREE_SHIP = 5000; // 50 €

  /* ============================ Helpers ============================ */

  function canon(raw) {
    if (!raw) return 'sonstige';
    if (CAT_NORMALIZE[raw]) return CAT_NORMALIZE[raw];
    var low = String(raw).toLowerCase();
    return CAT_NORMALIZE[low] || low;
  }
  function money(cents) {
    if (cents === null || cents === undefined || cents === '') return '';
    var v = Number(cents) / 100;
    var s = (v % 1 === 0) ? v.toFixed(0) : v.toFixed(2).replace('.', ',');
    return s + ' €';
  }
  function discountPct(price, compare) {
    if (!compare || compare <= price) return 0;
    return Math.round((1 - price / compare) * 100);
  }
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function cleanTitle(t) {
    return String(t || '').replace(/ergovo/ig, '').replace(/\s{2,}/g, ' ').trim();
  }

  var _catalog = null;
  function getCatalog() {
    if (_catalog) return _catalog;
    try {
      var el = document.getElementById('ergovo-recs-catalog');
      _catalog = el ? JSON.parse(el.textContent) : [];
    } catch (e) { _catalog = []; }
    return _catalog;
  }
  function fetchCart() {
    var base = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(base + '.js', { headers: { Accept: 'application/json' } }).then(function (r) {
      return r.ok ? r.json() : { items: [], item_count: 0 };
    }).catch(function () { return { items: [], item_count: 0 }; });
  }
  function getCartDrawer() { return document.querySelector('cart-drawer'); }

  /* ========================= Smart-Recs ============================ */

  /*
   * Ergovo Pin-Konfiguration
   * 'always'        -> die fixierte Upsell-Option ist IMMER erste Empfehlung
   * 'with-deepsleep'-> nur pinnen, wenn das DeepSleep-Kissen im Warenkorb liegt
   * Datenquelle: #ergovo-recs-pinned (gerendert in snippets/ergovo-recs-catalog.liquid)
   */
  var PIN_MODE = 'with-deepsleep';
  var _pinned = null, _pinnedRead = false;
  function getPinned() {
    if (_pinnedRead) return _pinned;
    _pinnedRead = true;
    try {
      var el = document.getElementById('ergovo-recs-pinned');
      var obj = el ? JSON.parse(el.textContent) : null;
      _pinned = (obj && obj.handle) ? obj : null;
    } catch (e) { _pinned = null; }
    return _pinned;
  }

  function scoreRecs(cart, opts) {
    opts = opts || {};
    var catalog = getCatalog();
    if (!catalog.length) return [];
    var items = (cart && cart.items) || [];
    var inCart = {}, cartCats = {};
    items.forEach(function (it) {
      if (it.handle) inCart[it.handle] = true;
      var c = canon(it.product_type);
      cartCats[c] = (cartCats[c] || 0) + 1;
    });
    if (opts.excludeHandle) inCart[opts.excludeHandle] = true;

    var target = {};
    Object.keys(cartCats).forEach(function (cc) {
      var list = AFFINITY[cc];
      if (!list) return;
      var w = cartCats[cc];
      list.forEach(function (tc, idx) { target[tc] = (target[tc] || 0) + (list.length - idx) * w; });
    });

    var scored = catalog.map(function (p, idx) {
      if (inCart[p.handle]) return null;
      var score = target[canon(p.cat)] || 0;
      var prior = (p.available ? 0.5 : 0) + (catalog.length - idx) * 0.001;
      return { p: p, score: score + prior, hasAffinity: score > 0 };
    }).filter(Boolean);

    var withAff = scored.filter(function (x) { return x.hasAffinity; }).sort(function (a, b) { return b.score - a.score; });
    var fillers = scored.filter(function (x) { return !x.hasAffinity; }).sort(function (a, b) { return b.score - a.score; });
    var ordered = withAff.concat(fillers).map(function (x) { return x.p; });

    // -- Ergovo Pin: DeepSleep Ersatzbezug IMMER als erste Upsell-Option --
    // Mobile-Zeile, Desktop-Seitenpanel und Quick-View laufen alle ueber scoreRecs,
    // daher greift dieser eine Eingriff an allen Stellen. Nicht pinnen, wenn das
    // Produkt bereits im Warenkorb liegt oder es das aktuell offene QV-Produkt ist.
    var pinned = getPinned();
    if (pinned && pinned.handle && pinned.available !== false &&
        !inCart[pinned.handle] && opts.excludeHandle !== pinned.handle) {
      var pinOk = (PIN_MODE === 'with-deepsleep') ? !!inCart['deepsleep'] : true;
      if (pinOk) {
        ordered = ordered.filter(function (p) { return p.handle !== pinned.handle; });
        ordered.unshift(pinned);
      }
    }
    return ordered.slice(0, opts.limit || REC_LIMIT);
  }

  function recCardHTML(p) {
    var pct = discountPct(p.price, p.compare);
    return '' +
      '<div class="ergovo-rec">' +
        '<a class="ergovo-rec__media" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">' +
          (p.img ? '<img src="' + esc(p.img) + '" alt="' + esc(p.title) + '" width="120" height="120" loading="lazy">' : '') +
          (pct ? '<span class="ergovo-rec__badge">-' + pct + '%</span>' : '') +
        '</a>' +
        '<div class="ergovo-rec__info">' +
          '<a class="ergovo-rec__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="ergovo-rec__price">' +
            '<span class="ergovo-rec__now">' + money(p.price) + '</span>' +
            (pct ? '<s class="ergovo-rec__was">' + money(p.compare) + '</s>' : '') +
          '</div>' +
          '<button type="button" class="ergovo-rec__btn" data-rec-qv="' + esc(p.handle) + '">Schnellansicht</button>' +
        '</div>' +
      '</div>';
  }

  function renderInto(track, list) {
    if (!track) return;
    var html = list.length ? list.map(recCardHTML).join('') : '';
    if (track.innerHTML !== html) track.innerHTML = html; // nur bei echter Änderung schreiben (verhindert Mutation-Churn)
  }

  var _lastSig = '';
  function refreshRecs(force) {
    return fetchCart().then(function (cart) {
      // Recs-Tracks im Drawer – ABER nicht den Quick-View-eigenen Track
      var tracks = document.querySelectorAll('#CartDrawer .ergovo-recs__track:not([data-qv-recs])');
      var wraps = document.querySelectorAll('#CartDrawer .ergovo-recs:not(.ergovo-recs--qv), #CartDrawer .ergovo-recs-side');
      if (!tracks.length) return;

      var sig = (cart.items || []).map(function (i) { return i.handle + 'x' + i.quantity; }).join('|');
      if (!force && sig === _lastSig) {
        var filled = true;
        tracks.forEach(function (t) { if (!t.children.length) filled = false; });
        if (filled) return;
      }
      _lastSig = sig;

      var list = (cart.items && cart.items.length) ? scoreRecs(cart, { limit: REC_LIMIT }) : [];
      tracks.forEach(function (t) { renderInto(t, list); });
      wraps.forEach(function (w) { w.style.display = list.length ? '' : 'none'; });
    });
  }

  /* ========================= Add to cart =========================== */

  function addVariant(variantId, qty, btn) {
    qty = qty || 1;
    var drawer = getCartDrawer();
    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', qty);
    fd.append('sections', 'cart-drawer,cart-icon-bubble');
    fd.append('sections_url', window.location.pathname);
    if (btn) btn.classList.add('loading');
    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
    return fetch(addUrl, {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { return res; }
        // Quick View vorher schließen, damit nach dem Re-Render der Warenkorb sichtbar ist
        QV.close();
        if (drawer && typeof drawer.renderContents === 'function') { drawer.renderContents(res); }
        else { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true })); }
        scheduleRefresh(true); // EIN debounce-Kanal statt mehrfacher paralleler Refreshes
        return res;
      })
      .catch(function () {})
      .finally(function () { if (btn) btn.classList.remove('loading'); });
  }

  /* ===================== Quick View (In-Drawer) ==================== */

  var QV = {
    panel: null, body: null, product: null, selected: [], optionNames: [], _opener: null,

    el: function () { return document.getElementById('ergovo-qv'); },
    optionName: function (o) { return (o && typeof o === 'object') ? o.name : o; },

    open: function (handle, opener) {
      var panel = this.el();
      if (!panel) return;
      this.panel = panel;
      this.body = panel.querySelector('#ergovo-qv-body') || document.getElementById('ergovo-qv-body');
      if (!this.body) return;
      var wasOpen = panel.classList.contains('is-open');
      if (!wasOpen && opener) this._opener = opener; // Fokus-Rückgabeziel merken (A11y)
      panel.hidden = false;
      if (!wasOpen) {
        void panel.offsetWidth; panel.classList.add('is-open');
        var back = panel.querySelector('.ergovo-qv__back');
        if (back) { try { back.focus(); } catch (e) {} } // Fokus ins Panel
      }
      var sc = panel.querySelector('.ergovo-qv__scroll');
      if (sc) sc.scrollTop = 0;
      this.body.innerHTML = '<div class="ergovo-qv__loading"><span class="ergovo-qv__spin"></span></div>';
      var self = this;
      fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (product) { self.render(product); })
        .catch(function () { self.body.innerHTML = '<div class="ergovo-qv__loading">Konnte Produkt nicht laden.</div>'; });
    },

    close: function () {
      var panel = this.panel || this.el();
      if (!panel || panel.hidden) return;
      panel.classList.remove('is-open');
      var done = function () { panel.hidden = true; panel.removeEventListener('transitionend', done); };
      panel.addEventListener('transitionend', done);
      setTimeout(function () { if (!panel.classList.contains('is-open')) panel.hidden = true; }, 360);
      this.product = null;
      var op = this._opener; this._opener = null;
      if (op && typeof op.focus === 'function') { try { op.focus(); } catch (e) {} } // Fokus zurückgeben
    },

    render: function (product) {
      this.product = product;
      var cat = canon(product.type);
      var trialDays = (product.handle === 'deepsleep' || product.handle === 'ergovo-deepsleep-ersatzbezug') ? 30 : 14;
      var trustBadges = TRUST_BADGES.concat([{ t: trialDays + ' Tage', s: 'risikofrei testen' }]);
      var single = !product.options || product.options.length === 0 ||
        (product.options.length === 1 && (this.optionName(product.options[0]) === 'Title'));
      this.optionNames = single ? [] : product.options.map(this.optionName);

      var def = null;
      for (var i = 0; i < product.variants.length; i++) { if (product.variants[i].available) { def = product.variants[i]; break; } }
      if (!def) def = product.variants[0];
      this.selected = single ? [] : [def.option1, def.option2, def.option3].slice(0, this.optionNames.length);

      var bullets = (BULLETS_BY_HANDLE[product.handle] || BULLETS[cat] || BULLETS.default).slice(0, 4);
      var img = (product.featured_image || (product.media && product.media[0] && product.media[0].preview_image && product.media[0].preview_image.src) || '');
      if (img && img.indexOf('//') === 0) img = window.location.protocol + img;
      // korrektes Query-Trennzeichen (Shopify-CDN-URLs haben i. d. R. schon ?v=…)
      var imgSized = img ? (img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=320') : '';
      var pct = discountPct(def.price, def.compare_at_price);
      var title = cleanTitle(product.title);
      // Versandtext: Produkte über 50 € qualifizieren immer → ohne "ab 50 €"
      var shipTxt = (def.price >= FREE_SHIP) ? 'Kostenloser Expressversand' : 'Kostenloser Expressversand ab 50 €';

      var html = '' +
        '<div class="ergovo-qv__top">' +
          '<div class="ergovo-qv__thumb">' +
            (imgSized ? '<img src="' + esc(imgSized) + '" alt="' + esc(title) + '">' : '') +
            '<span class="ergovo-qv__badge" data-qv-badge' + (pct ? '' : ' hidden') + '>-' + pct + '%</span>' +
          '</div>' +
          '<div class="ergovo-qv__head-info">' +
            '<h2 class="ergovo-qv__title">' + esc(title) + '</h2>' +
            '<div class="ergovo-qv__price">' +
              '<span class="ergovo-qv__now" data-qv-price>' + money(def.price) + '</span>' +
              '<s class="ergovo-qv__was" data-qv-compare ' + (pct ? '' : 'hidden') + '>' + money(def.compare_at_price) + '</s>' +
            '</div>' +
            (product.handle === 'ergovo-deepsleep-ersatzbezug' ? '' : '<a class="ergovo-qv__details" href="/products/' + esc(product.handle) + '">Mehr Details</a>') +
            '<div class="ergovo-qv__tax" data-qv-ship>' + shipTxt + '</div>' +
          '</div>' +
        '</div>' +

        '<ul class="ergovo-qv__bullets">' +
          bullets.map(function (b) {
            return '<li><svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg>' + esc(b) + '</li>';
          }).join('') +
        '</ul>' +

        '<div class="ergovo-qv__stock" data-qv-stock>' +
          '<span class="ergovo-qv__dot"></span><span data-qv-stock-text>Auf Lager · versandfertig</span>' +
        '</div>' +

        '<div class="ergovo-qv__urgency">' +
          '<strong>Aktuell stark gefragt.</strong> Dieses Modell ist beliebt und nur in begrenzter Stückzahl da – am besten gleich deine Variante sichern.' +
        '</div>' +

        this.optionsHTML(product) +

        '<button type="button" class="ergovo-qv__atc" data-qv-atc data-vid="' + esc(def.id) + '" ' + (def.available ? '' : 'disabled') + '>' +
          (def.available ? 'In den Warenkorb' : 'Ausverkauft') +
        '</button>' +

        '<div class="ergovo-qv__trust">' +
          trustBadges.map(function (b) {
            return '<div class="ergovo-qv__trust-item"><span class="ergovo-qv__trust-t">' + esc(b.t) + '</span><span class="ergovo-qv__trust-s">' + esc(b.s) + '</span></div>';
          }).join('') +
        '</div>' +

        '<div class="ergovo-recs ergovo-recs--qv">' +
          '<div class="ergovo-recs__title">Entdecke mehr</div>' +
          '<div class="ergovo-recs__track" data-qv-recs></div>' +
        '</div>';

      this.body.innerHTML = html;
      this.wire();
      this.renderQvRecs(product.handle);
    },

    optionsHTML: function (product) {
      if (!this.optionNames.length) return '';
      var self = this;
      var out = '<div class="ergovo-qv__options">';
      this.optionNames.forEach(function (name, i) {
        var values = [];
        product.variants.forEach(function (v) {
          var val = v['option' + (i + 1)];
          if (val && values.indexOf(val) === -1) values.push(val);
        });
        var isColor = /farbe|color|colour/i.test(name);
        out += '<div class="ergovo-qv__opt" data-opt="' + i + '">' +
          '<div class="ergovo-qv__opt-name">' + esc(name) + ': <span data-opt-sel="' + i + '">' + esc(self.selected[i] || '') + '</span></div>' +
          '<div class="ergovo-qv__opt-vals' + (isColor ? ' is-color' : '') + '">';
        values.forEach(function (val) {
          var sel = (self.selected[i] === val) ? ' is-selected' : '';
          if (isColor) {
            var hex = COLOR_HEX[String(val).toLowerCase()] || '#cccccc';
            out += '<button type="button" class="ergovo-qv__swatch' + sel + '" data-opt-idx="' + i + '" data-val="' + esc(val) + '" title="' + esc(val) + '" aria-label="' + esc(val) + '"><span style="background:' + hex + '"></span></button>';
          } else {
            out += '<button type="button" class="ergovo-qv__pill' + sel + '" data-opt-idx="' + i + '" data-val="' + esc(val) + '">' + esc(val) + '</button>';
          }
        });
        out += '</div></div>';
      });
      out += '</div>';
      return out;
    },

    findVariant: function () {
      var self = this;
      return this.product.variants.find(function (v) {
        for (var i = 0; i < self.optionNames.length; i++) {
          if (v['option' + (i + 1)] !== self.selected[i]) return false;
        }
        return true;
      });
    },

    wire: function () {
      var self = this;
      this.body.querySelectorAll('[data-opt-idx]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var idx = parseInt(btn.getAttribute('data-opt-idx'), 10);
          self.selected[idx] = btn.getAttribute('data-val');
          btn.parentNode.querySelectorAll('[data-opt-idx]').forEach(function (b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          var sl = self.body.querySelector('[data-opt-sel="' + idx + '"]');
          if (sl) sl.textContent = self.selected[idx];
          self.updateForVariant();
        });
      });
      var atc = this.body.querySelector('[data-qv-atc]');
      if (atc) atc.addEventListener('click', function () {
        var vid = atc.getAttribute('data-vid');
        if (!vid || atc.disabled) return;
        addVariant(vid, 1, atc);
      });
    },

    updateForVariant: function () {
      var v = this.findVariant();
      var atc = this.body.querySelector('[data-qv-atc]');
      var priceEl = this.body.querySelector('[data-qv-price]');
      var cmpEl = this.body.querySelector('[data-qv-compare]');
      var badge = this.body.querySelector('[data-qv-badge]');
      var stockTxt = this.body.querySelector('[data-qv-stock-text]');
      var stock = this.body.querySelector('[data-qv-stock]');
      var shipEl = this.body.querySelector('[data-qv-ship]');
      if (!v) { if (atc) { atc.disabled = true; atc.textContent = 'Kombination nicht verfügbar'; } return; }
      if (priceEl) priceEl.textContent = money(v.price);
      if (shipEl) shipEl.textContent = (v.price >= FREE_SHIP) ? 'Kostenloser Expressversand' : 'Kostenloser Expressversand ab 50 €';
      var pct = discountPct(v.price, v.compare_at_price);
      if (cmpEl) { if (pct) { cmpEl.hidden = false; cmpEl.textContent = money(v.compare_at_price); } else { cmpEl.hidden = true; } }
      if (badge) { if (pct) { badge.hidden = false; badge.textContent = '-' + pct + '%'; } else { badge.hidden = true; } }
      if (atc) { atc.disabled = !v.available; atc.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft'; atc.setAttribute('data-vid', v.id); }
      if (stock && stockTxt) { stock.classList.toggle('is-out', !v.available); stockTxt.textContent = v.available ? 'Auf Lager · versandfertig' : 'Derzeit nicht verfügbar'; }
      var urg = this.body.querySelector('.ergovo-qv__urgency'); if (urg) urg.style.display = v.available ? '' : 'none';
    },

    renderQvRecs: function (handle) {
      var track = this.body.querySelector('[data-qv-recs]');
      if (!track) return;
      var self = this;
      fetchCart().then(function (cart) {
        var list = scoreRecs(cart, { limit: QV_REC_LIMIT, excludeHandle: handle });
        renderInto(track, list);
        var wrap = self.body.querySelector('.ergovo-recs--qv');
        if (wrap) wrap.style.display = list.length ? '' : 'none';
      });
    }
  };

  /* ===================== Globale Click-Delegation ================= */

  document.addEventListener('click', function (e) {
    var qvBtn = e.target.closest('[data-rec-qv]');
    if (qvBtn) { e.preventDefault(); QV.open(qvBtn.getAttribute('data-rec-qv'), qvBtn); return; }
    if (e.target.closest('[data-qv-close]')) { e.preventDefault(); QV.close(); return; }
    var dc = e.target.closest('[data-drawer-close]');
    if (dc) { e.preventDefault(); QV.close(); var d = getCartDrawer(); if (d && d.close) d.close(); return; }
  });

  document.addEventListener('keyup', function (e) {
    if (e.key !== 'Escape') return;
    var p = QV.el();
    if (p && p.classList.contains('is-open')) QV.close();
  });

  /* ===================== Cart-Sync ================================= */

  function updateHeaderCount(cart) {
    var n = cart ? cart.item_count : null;
    document.querySelectorAll('[data-ergovo-cart-count]').forEach(function (el) {
      if (n === null) return;
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  // Versand-Bar: störendes Emoji (🎉/Konfetti/Symbole) aus der Ziel-Nachricht entfernen
  function stripGoalEmoji() {
    document.querySelectorAll('#CartDrawer .goal-message').forEach(function (el) {
      var h = el.innerHTML;
      var cleaned = h.replace(/[\u{1F300}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}\u{200D}]/gu, '').replace(/^(?:\s|&nbsp;)+/, '');
      if (cleaned !== h) el.innerHTML = cleaned;
    });
  }

  var _t = null;
  function scheduleRefresh(force) {
    clearTimeout(_t);
    _t = setTimeout(function () {
      stripGoalEmoji();
      fetchCart().then(function (cart) { updateHeaderCount(cart); refreshRecs(force); });
    }, 120);
  }

  try {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () { scheduleRefresh(true); });
    }
  } catch (e) {}

  document.addEventListener('cart:refresh', function () { scheduleRefresh(true); });
  document.addEventListener('cart:updated', function () { scheduleRefresh(true); });

  (function () {
    if (window.__ergovoCartFetchHook) return;
    window.__ergovoCartFetchHook = true;
    var orig = window.fetch;
    window.fetch = function () {
      var url = (typeof arguments[0] === 'string') ? arguments[0] : (arguments[0] && arguments[0].url) || '';
      // NUR same-origin /cart-Mutationen behandeln – keine fremden App-/API-URLs stören
      var sameOrigin = url.charAt(0) === '/' || (location.origin && url.indexOf(location.origin) === 0);
      var isMut = sameOrigin && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url);
      var p = orig.apply(this, arguments);
      if (isMut) { p.then(function () { scheduleRefresh(true); }).catch(function () {}); }
      return p;
    };
  })();

  function observeDrawer() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer || drawer.__ergovoObs) return;
    drawer.__ergovoObs = true;
    var moT = null;
    var mo = new MutationObserver(function () {
      clearTimeout(moT); // debounce: viele Mutationen zu EINEM Check zusammenfassen
      moT = setTimeout(function () {
        var tracks = drawer.querySelectorAll('.ergovo-recs__track:not([data-qv-recs])');
        var anyEmpty = false;
        tracks.forEach(function (t) { if (!t.children.length) anyEmpty = true; });
        if (anyEmpty) refreshRecs(false);
        stripGoalEmoji();
      }, 150);
    });
    mo.observe(drawer, { childList: true, subtree: true });
  }

  // Nach /cart-Redirect (z. B. Warenkorb-Button im Checkout): eigenen Drawer öffnen
  function maybeOpenCartAfterRedirect() {
    try {
      if (!sessionStorage.getItem('ergovoOpenCart')) return;
      sessionStorage.removeItem('ergovoOpenCart');
      var tries = 0;
      var t = setInterval(function () {
        var d = getCartDrawer();
        if (d && typeof d.open === 'function') { d.open(); clearInterval(t); }
        if (++tries > 40) clearInterval(t);
      }, 100);
    } catch (e) {}
  }

  function init() { observeDrawer(); scheduleRefresh(true); maybeOpenCartAfterRedirect(); stripGoalEmoji(); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }

  window.ErgovoCart = { refreshRecs: refreshRecs, openQuickView: function (h) { QV.open(h); }, addVariant: addVariant };
})();

/* Bestseller-Section CTA "Alle anzeigen": Ziel = Bestseller-Collection statt /collections/all.
   Greift NUR, solange im Theme-Editor kein eigener Button-Link gesetzt ist (Fallback-URL). */
(function () {
  function fixBestsellerCta() {
    var links = document.querySelectorAll('a.pr__cta');
    for (var i = 0; i < links.length; i++) {
      var href = links[i].getAttribute('href') || '';
      if (href === '/collections/all' || href.slice(-16) === '/collections/all') {
        links[i].setAttribute('href', '/collections/bestseller');
      }
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fixBestsellerCta); }
  else { fixBestsellerCta(); }
})();
